// @ts-nocheck
/**
 * PhotoConsentModal Component
 * 
 * COPPA-compliant consent modal for photo analysis.
 * Extracted from App.tsx to reduce file size.
 * 
 * @author Heseda AI Team
 * @version 1.0
 */

import React from 'react';
import { useTranslation } from 'react-i18next';

interface PhotoConsentModalProps {
  language: string;
  onAccept: () => void;
  onCancel: () => void;
}

/**
 * Photo consent modal for COPPA compliance
 */
function PhotoConsentModal({
  language,
  onAccept,
  onCancel,
}: PhotoConsentModalProps) {
  const { t } = useTranslation(['modals']);
  
  return (
    <div className="modal-overlay">
      <div className="modal-content consent-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{t('photoConsent.title')}</h3>
        </div>
        <div className="modal-body">
          <p style={{ marginBottom: '16px', lineHeight: '1.6' }}>
            {t('photoConsent.description')}
          </p>
          <ul style={{ marginBottom: '20px', paddingLeft: '20px', lineHeight: '1.8' }}>
            <li>{t('photoConsent.items.upload')}</li>
            <li>{t('photoConsent.items.store')}</li>
            <li>{t('photoConsent.items.recommend')}</li>
          </ul>
          <p style={{ marginBottom: '20px', fontSize: '14px', color: '#666' }}>
            {t('photoConsent.privacy')}
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
            <button 
              className="modal-btn modal-btn--secondary" 
              onClick={onCancel}
            >
              {t('photoConsent.cancel')}
            </button>
            <button 
              className="modal-btn modal-btn--primary" 
              onClick={onAccept}
            >
              {t('photoConsent.agree')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PhotoConsentModal;
